export default {
  props: {
    inputIndex: {
      required: true,
      type: Number
    },
    input: {
      required: true,
      type: Object
    },
    errors: {
      required: false
    }
  }
}
